import styled from 'styled-components';

export const SFirmLevelDemandHeader = styled.div`
  flex: 1;
  justify-content: flex-end;
  flex-wrap: nowrap;
  align-items: center;
  display: flex;
`;
